import React, { useState } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./style/form.css"



function FormDash() {

  const navigate = useNavigate();
  const [shopInfo,setInfo] = useState({
      ownerName: "",
      shopName: "",
      email: "",
      gpayID: "",
      location: "",
      gstIN: "",
      status:"closed"
      
  });

  const handleChange = (event)=>{
    const {name,value} = event.target
    setInfo((previousState)=>
    {
        return{...previousState,[name]:value}
    })

    
}
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(shopInfo);

    await axios.post('https://dfghtyudgh.onrender.com/store/create',shopInfo)
        .then(response=>{
            console.log(response)
            navigate('/dashboard/')
        })
        .catch(error=>{
            console.log(error)
        })

       

  }; 
  return(
    <form onSubmit={handleSubmit}>
     <div className='form-container'><div>
        <label htmlFor="ownername">Owner Name:</label>
        <input
          type="text"
          name="ownerName"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="shopname">Shop Name:</label>
        <input
          type="text"
          name="shopName"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          name="email"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="gpayId">Google Pay ID:</label>
        <input
          type="text"
          name="gpayID"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="location">Location:</label>
        <input
          type="text"
          name="location"
          onChange={handleChange}
        />
      </div>
      <div>
        <label htmlFor="gstIn">GSTIN:</label>
        <input
          type="text"
          name="gstIN"
          onChange={handleChange}
        />
      </div>
      <button type="submit">Submit</button>
      </div> 
    </form>
    
  );
}

export default FormDash;
